import context from '@truckdown/components-systems';
import { IListingService } from './IListingService';

context.registerService({
    name: 'IListingService',
    activator: async () => {
        var svc = await import(/* webpackChunkName: "comp-locations-listing-service" */ './ListingService');
        return new svc.ListingService(context) as IListingService;
    }
})
